import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ship-details" }
const _hoisted_2 = { class: "ship-details__group" }
const _hoisted_3 = { class: "ship-details__list" }
const _hoisted_4 = { class: "ship-details__label" }
const _hoisted_5 = { class: "ship-details__value" }
const _hoisted_6 = { class: "ship-details__group" }
const _hoisted_7 = { class: "ship-details__list" }
const _hoisted_8 = { class: "ship-details__label" }
const _hoisted_9 = { class: "ship-details__value" }
const _hoisted_10 = { class: "ship-details__group" }
const _hoisted_11 = { class: "ship-details__list" }
const _hoisted_12 = { class: "ship-details__label" }
const _hoisted_13 = { class: "ship-details__value" }

import { computed } from 'vue';

import { useUtil } from "@/services/util-service";
import { ISearchResultItem } from 'interfaces/search/ISearchResultItem';

type ShipDetailItem = {
  label: string;
  value: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ShipDetails',
  props: {
    ship: {}
  },
  setup(__props: any) {

const props = __props;

const getMeterValue = (value: number | null | undefined): string => {
  return value ? `${useUtil().formatNumber(value)} meter` : '-';
}

const getValue = (value: string | number | null | undefined): string | number => {
  return value ? value : '-';
}

const getValueText = (value: string | number | null | undefined): string => {
  const formattedValue = getValue(value);
  return `${formattedValue}`;
}

const getArrayValue = (values: string[] | null | undefined): string => {
  return values?.length ? values.join(', ') : '-';
}

const eventItems = computed<ShipDetailItem[]>(() => [
  { label: 'Alternativa namn', value: getArrayValue(props.ship?.alternateNames) },
  { label: 'Sjösatt/Infört i flottan', value: getValueText(props.ship?.launchDate) },
  { label: 'Avslut/Avfört ur flottan', value: getValueText(props.ship?.suspension) },
  { label: 'Öde', value: getArrayValue(props.ship?.fates) },
  { label: 'Lägesbestämd', value: getValueText(props.ship?.status) },
  { label: 'Deltog i', value: getArrayValue(props.ship?.navalBattles) },
]);

const constructionItems = computed<ShipDetailItem[]>(() => [
  { label: 'Byggnadsort', value: getValueText(props.ship?.constructionSite) },
  { label: 'Byggmästare', value: getValueText(props.ship?.constructor) },
  { label: 'Typ', value: getValueText(props.ship?.type) },
  { label: 'Längd', value: getValueText(getMeterValue(props.ship?.length)) },
  { label: 'Bredd', value: getValueText(getMeterValue(props.ship?.width)) },
  { label: 'Ton', value: getValueText(props.ship?.displacement) },
]);

const crewItems = computed<ShipDetailItem[]>(() => [
  { label: 'Kanoner', value: getValueText(props.ship?.numberOfCannons) },
  { label: 'Sjöfolk', value: getValueText(props.ship?.numberOfSailors) },
  { label: 'Soldater', value: getValueText(props.ship?.numberOfSoldiers) },
  { label: 'Total besättning', value: getValueText(props.ship?.crewTotal) },
]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "ship-details__heading" }, [
        _createElementVNode("span", {
          class: "icon icon--ship",
          "aria-hidden": "true"
        }),
        _createTextVNode(" Händelser ")
      ], -1 /* HOISTED */)),
      _createElementVNode("dl", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventItems.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.label,
            class: "ship-details__item"
          }, [
            _createElementVNode("dt", _hoisted_4, _toDisplayString(item.label), 1 /* TEXT */),
            _createElementVNode("dd", _hoisted_5, _toDisplayString(item.value), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "ship-details__heading" }, [
        _createElementVNode("span", {
          class: "icon icon--wrench",
          "aria-hidden": "true"
        }),
        _createTextVNode(" Konstruktion ")
      ], -1 /* HOISTED */)),
      _createElementVNode("dl", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructionItems.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.label,
            class: "ship-details__item"
          }, [
            _createElementVNode("dt", _hoisted_8, _toDisplayString(item.label), 1 /* TEXT */),
            _createElementVNode("dd", _hoisted_9, _toDisplayString(item.value), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "ship-details__heading" }, [
        _createElementVNode("span", {
          class: "icon icon--earth",
          "aria-hidden": "true"
        }),
        _createTextVNode(" Bestyckning/Besättning ")
      ], -1 /* HOISTED */)),
      _createElementVNode("dl", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(crewItems.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.label,
            class: "ship-details__item"
          }, [
            _createElementVNode("dt", _hoisted_12, _toDisplayString(item.label), 1 /* TEXT */),
            _createElementVNode("dd", _hoisted_13, _toDisplayString(item.value), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}
}

})